import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import {
    AppNotificationService,
    AppNotificationType,
    ApprovedPCHDurationModel,
    ENDPOINTS,
    EventService,
    ODataApprovedPCHDurationResponseModel,
    OnlineOnlyService,
} from '@evorait/pace-core';
import { catchError, EMPTY, finalize, Subject, takeUntil } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'pace-pch-duration',
    templateUrl: './pch-duration.component.html',
})
export class PCHDurationComponent implements OnInit, OnDestroy {
    @Input() public model: ApprovedPCHDurationModel;

    public approvedPCHForm: FormGroup;
    public formChildren: FormArray;
    public pchUpdateInProgress = false;

    private destroy$ = new Subject<void>();

    public constructor(
        private readonly modalInstance: BsModalRef,
        private readonly formBuilder: FormBuilder,
        private readonly onlineOnlyService: OnlineOnlyService,
        private readonly appNotificationService: AppNotificationService,
        private readonly translate: TranslateService,
        private readonly eventService: EventService,
    ) {}

    public ngOnInit(): void {
        this.formChildren = this.formBuilder.array([]);
        this.approvedPCHForm = this.formBuilder.group({
            formChildren: this.formChildren,
        });
    }

    public closeModal(): void {
        this.modalInstance.hide();
    }

    public updatePCHDuration(): void {
        this.pchUpdateInProgress = true;
        this.onlineOnlyService
            .post<ODataApprovedPCHDurationResponseModel>(ENDPOINTS.ApprovedPCHDuractionChange, this.model.getOutModel())
            .pipe(
                takeUntil(this.destroy$),
                catchError((error) => {
                    this.appNotificationService.setAppNotification(
                        AppNotificationType.ERROR,
                        <string>this.translate.instant('NOTIFICATION_DETAILS_UPDATE_PCH_DURATION_ERROR_TITLE'),
                        `${<string>this.translate.instant('NOTIFICATION_DETAILS_UPDATE_PCH_DURATION_ERROR_BODY')} ${JSON.stringify(error)}`,
                    );

                    return EMPTY;
                }),
                finalize(() => (this.pchUpdateInProgress = false)),
            )
            .subscribe(() => {
                this.model.updateApprovedPCHDuration();
                this.eventService.triggerNotificationRefreshRequiredChanged(true);
                this.closeModal();
            });
    }

    public ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
